<page-content [fullPageWidth]="false">
    <header-elitment header
            [hasSideMenu]="hasLibrary">
    </header-elitment>
    <side-menu *ngIf="hasLibrary"
               left-menu>
        <libraries-side-menu></libraries-side-menu>
    </side-menu>
    <error-401 *ngIf="is401"></error-401>

  <ng-container *ngIf="is404">
        <div fxLayout="column" fxLayoutAlign="center center" style="height: 100%">
            <div style="padding: 50px 0">
                {{ 'Session_no_longer_exists' | translate }}
            </div>
        </div>
    </ng-container>

    <ng-container *ngIf="!is404">
        <sessions-session-view *ngIf="!is401 && !is404"
                            [organization]="organization"
                            [session]="session"
                            [showLeftPanel]="false"
        >

        </sessions-session-view>
    </ng-container>
</page-content>

